// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/images-update/sign-up/select.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar_gradient{
  background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(255, 255, 255, 0) 100%);
}

/* For Webkit-based browsers (Chrome, Safari and Opera) */
.sidebar > div::-webkit-scrollbar, .modal-popup > div::-webkit-scrollbar {
  display: none;
}

/* Added for Account Management */
.modal-popup > div::-webkit-scrollbar,
.tabContent::-webkit-scrollbar{
  display: none;
}

/* For IE, Edge and Firefox */
.sidebar > div {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

select, .dropdown:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right ;
  -webkit-appearance: none;
  background-position-x: 95%;
  top: 33px;
}

.label {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
}
.label input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.label__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #fff;
}
.label__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.label .label__indicator:after {
  left: 6px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.label input:checked ~ .label__indicator{
  border: 3px solid #fff;

}
.label input:checked ~ .label__indicator:after {
  display: block;
}

/* Swiper */
/* #Swiper-1{
  overflow: inherit !important;
}
#Swiper-1 .swiper-pagination{
  bottom: 105% !important;
  display: flex;
} */
#Swiper-1 .swiper-pagination {
  bottom: -20% !important;
}
.ytp-chrome-top.ytp-show-cards-title {
  display: none;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active{
  background-color: #fff;
}
.swiper-pagination-bullet:not(.swiper-pagination-bullet-active){
  background-color: transparent;
}
.exploreDots.swiper-pagination-bullet-active{
  background-color: #40BCEC;
}

.form-error {
  color: red;
  background: white;
  text-align: center;
  font-weight: bold;
}

.magma-col {
  color: red;
}

/* lines bar */
.line_bar{
  position: relative;
}
.line_bar:after{
  position: absolute;
  content: '';
  left: 5%;
  bottom: 0;
  height: 10px;
  width: 0;
  transition: 0.3s ease-in-out;
}
.line_bar:hover::after{
  width: 95%;
}
.focus-border{
  position: absolute;
  left: 0;
  bottom: 10px;
  height: 10px;
  width: 0;
  transition: 0.3s ease-in-out;
}
.input_bar:focus ~ .focus-border{
  width: 100%;
  transition: 0.3s ease-in-out;
}

.text_dark {
  text-shadow: 2px 2px 3px #000000;
}

.text_dark_low {
  text-shadow: 1px 1px 1px #000000;
}

.ev-lh {
  line-height: 1.6rem;
}

/* ****** */
@media (max-width : 1279px){
  .focus-border{
    bottom: 0;
  }
}
/* @media (max-width : 1200px){
  #Swiper-1 .swiper-pagination{
    bottom: 107% !important;
    padding-left: 70px;
  }
}
@media (max-width : 991px){
  #Swiper-1 .swiper-pagination{
    bottom: 109% !important;
    padding-left: 60px;
  }
}
@media (max-width : 640px){
  #Swiper-1 .swiper-pagination{
    bottom: 106% !important;
    padding-left: 60px;
  }
} */

.triangle-container {
  width: 40px;
  height: 28px;
  position: relative;
  transform: rotate(180deg);
}

.triangle {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  stroke: #fff;
  fill: none;
  stroke-width: 4px;
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: stroke 2s ease-in-out infinite;
}

@keyframes stroke {
  to {
    stroke-dashoffset: 0;
  }
}

.grecaptcha-badge { 
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oFAAoF;AACtF;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;;EAEE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,oEAAoF;EACpF,wBAAwB;EACxB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;;AAExB;AACA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;;;;;;GAMG;AACH;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,QAAQ;EACR,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,SAAS;EACX;AACF;AACA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".bar_gradient{\n  background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(255, 255, 255, 0) 100%);\n}\n\n/* For Webkit-based browsers (Chrome, Safari and Opera) */\n.sidebar > div::-webkit-scrollbar, .modal-popup > div::-webkit-scrollbar {\n  display: none;\n}\n\n/* Added for Account Management */\n.modal-popup > div::-webkit-scrollbar,\n.tabContent::-webkit-scrollbar{\n  display: none;\n}\n\n/* For IE, Edge and Firefox */\n.sidebar > div {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\nselect, .dropdown:after {\n  background: url('./assets/images/images-update/sign-up/select.svg') no-repeat right ;\n  -webkit-appearance: none;\n  background-position-x: 95%;\n  top: 33px;\n}\n\n.label {\n  display: block;\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n.label input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.label__indicator {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  border: 1px solid #fff;\n}\n.label__indicator:after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n.label .label__indicator:after {\n  left: 6px;\n  top: 2px;\n  width: 4px;\n  height: 9px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n.label input:checked ~ .label__indicator{\n  border: 3px solid #fff;\n\n}\n.label input:checked ~ .label__indicator:after {\n  display: block;\n}\n\n/* Swiper */\n/* #Swiper-1{\n  overflow: inherit !important;\n}\n#Swiper-1 .swiper-pagination{\n  bottom: 105% !important;\n  display: flex;\n} */\n#Swiper-1 .swiper-pagination {\n  bottom: -20% !important;\n}\n.ytp-chrome-top.ytp-show-cards-title {\n  display: none;\n}\n.swiper-pagination-bullet.swiper-pagination-bullet-active{\n  background-color: #fff;\n}\n.swiper-pagination-bullet:not(.swiper-pagination-bullet-active){\n  background-color: transparent;\n}\n.exploreDots.swiper-pagination-bullet-active{\n  background-color: #40BCEC;\n}\n\n.form-error {\n  color: red;\n  background: white;\n  text-align: center;\n  font-weight: bold;\n}\n\n.magma-col {\n  color: red;\n}\n\n/* lines bar */\n.line_bar{\n  position: relative;\n}\n.line_bar:after{\n  position: absolute;\n  content: '';\n  left: 5%;\n  bottom: 0;\n  height: 10px;\n  width: 0;\n  transition: 0.3s ease-in-out;\n}\n.line_bar:hover::after{\n  width: 95%;\n}\n.focus-border{\n  position: absolute;\n  left: 0;\n  bottom: 10px;\n  height: 10px;\n  width: 0;\n  transition: 0.3s ease-in-out;\n}\n.input_bar:focus ~ .focus-border{\n  width: 100%;\n  transition: 0.3s ease-in-out;\n}\n\n.text_dark {\n  text-shadow: 2px 2px 3px #000000;\n}\n\n.text_dark_low {\n  text-shadow: 1px 1px 1px #000000;\n}\n\n.ev-lh {\n  line-height: 1.6rem;\n}\n\n/* ****** */\n@media (max-width : 1279px){\n  .focus-border{\n    bottom: 0;\n  }\n}\n/* @media (max-width : 1200px){\n  #Swiper-1 .swiper-pagination{\n    bottom: 107% !important;\n    padding-left: 70px;\n  }\n}\n@media (max-width : 991px){\n  #Swiper-1 .swiper-pagination{\n    bottom: 109% !important;\n    padding-left: 60px;\n  }\n}\n@media (max-width : 640px){\n  #Swiper-1 .swiper-pagination{\n    bottom: 106% !important;\n    padding-left: 60px;\n  }\n} */\n\n.triangle-container {\n  width: 40px;\n  height: 28px;\n  position: relative;\n  transform: rotate(180deg);\n}\n\n.triangle {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  stroke: #fff;\n  fill: none;\n  stroke-width: 4px;\n  stroke-dasharray: 300;\n  stroke-dashoffset: 300;\n  animation: stroke 2s ease-in-out infinite;\n}\n\n@keyframes stroke {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n.grecaptcha-badge { \n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
